<template>
    <div id="personal-info-operate">
        <b-row>
            <b-col cols='4'>
                <div id="info-login-time">
                    <div class="in-info-login-time-avator" id="in-info-login-time-pic">
                        <b-img :src="avatar" id="info-login-time-avator" v-bind="avatorProps" rounded="circle" blank-color="#ff6699"></b-img>
                    </div>
                    <div class="in-info-login-time-avator" id="in-info-login-time-word">
                        <div><label id="info-login-time-name">{{ user.name }}</label></div>
                        <div><label id="info-login-time-time-tile">{{ $t('Home.lastLogin') }}</label><br/>
                        <label id="info-login-time-time">{{ lastLoginAt }}</label></div>
                    </div>
                </div>
            </b-col>
            <b-col cols='4'>
                <div class="personal-info-buttom-group">
                    <div class="devider">
                        <b-img :src="require('../../assets/HomePage/devider.png')" v-bind="deviderProps"></b-img>
                    </div>
                    <div class="personal-info-buttom-image-total" @click="personalInfo">
                        <div class="personal-info-buttom-image-box">
                            <b-img :src="require('../../assets/HomePage/dangan.png')" v-bind="infoButtomFileProps" class="personal-info-buttom-image"></b-img>
                        </div>
                        <div class="personal-info-buttom-word-box">
                            <label class="personal-info-buttom-word">查看个人档案</label>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col cols='4'>
                <div class="personal-info-buttom-group">
                    <div class="devider">
                        <b-img :src="require('../../assets/HomePage/devider.png')" v-bind="deviderProps"></b-img>
                    </div>
                    <div class="personal-info-buttom-image-total" @click="personalHistory">
                        <div class="personal-info-buttom-image-box">
                            <b-img :src="require('../../assets/HomePage/xuexichengji.png')" v-bind="infoButtomGradeProps" class="personal-info-buttom-image"></b-img>
                        </div>
                        <div class="personal-info-buttom-word-box">
                            <label class="personal-info-buttom-word">学习成绩记录</label>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { getUser } from '@/util/localStorage'

const PersonalInfo = Vue.extend({
  name: 'PersonalInfo',
  data: function () {
    var userData = getUser()
    var lastLoginAtDate = new Date()
    if (parseInt(userData.lastLoginAt) === 0) {
      lastLoginAtDate = this.$t('Auth.firstLogin')
    } else {
      lastLoginAtDate = lastLoginAtDate.getFullYear() +
        this.$t('Common.year') +
        (lastLoginAtDate.getMonth() + 1) +
        this.$t('Common.month') +
        (lastLoginAtDate.getDate()) +
        this.$t('Common.day') +
        ' ' +
        lastLoginAtDate.getHours() +
        ':' +
        lastLoginAtDate.getMinutes()
    }
    return {
      avatar: localStorage.avatar || require('../../assets/EditPersonalInfo/wo.png'),
      avatorProps: { blank: false, width: 75, height: 75, class: 'm1' },
      infoButtomFileProps: { blank: false, width: 21, height: 19, class: 'm1' },
      infoButtomGradeProps: { blank: false, width: 20, height: 21, class: 'm1' },
      deviderProps: { blank: false, width: 20, height: 80, class: 'm1' },
      //   name: localStorage.name,
      lastLoginAt: lastLoginAtDate,
      blank: ' '
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser
    }),
    stateAvatar () {
      return this.user.avatar
    }
  },
  watch: {
    stateAvatar () {
      if (this.$route.path !== '/userProfile') {
        this.avatar = localStorage.avatar
      }
    }
  },
  methods: {
    personalInfo () {
      if (this.user.gradeId === 18) {
        return
      }
      this.$router.push({
        name: 'userProfile'
      })
    },
    personalHistory () {
      this.$router.push({
        name: 'history'
      })
    }
  }
})
export default PersonalInfo
</script>

<style>
.test {
    text-align: center;
}
.personal-info-devider {
    text-align: center;
    font-size: 70px;
    color: #FFFFFF;
}
.in-info-login-time-avator {
    display: inline-block;
}
.personal-info-buttom-group {
    transform: translateY(40%);
}
.devider {
    position: absolute;
    top: 30%;
    left: 0;
    float: left;
}
.personal-info-buttom-image-total {
    display: inline-block;
    left: 50%;
    right: 50%;
    transform: translate(0%, 80%);
    cursor: pointer;
}
.personal-info-buttom-image-box {
    display: inline-block;
    width: 45px;
    height: 45px;
    border: 1px solid #FFFFFF;
    border-radius: 100%;
    transform: translateY(-15%);
}
.personal-info-buttom-image {
    margin: 0 auto;
    transform: translateY(35%);
}
.personal-info-buttom-word-box {
    display: inline-block;
    margin-left: 20px;
}
.personal-info-buttom-word {
    cursor: pointer;
}
#personal-info-operate {
    margin-left: auto;
    margin-right: auto;
    width: 1024px;
    background: #1D8F87;
    border-radius: 20px;
    color: #FFFFFF;
    height: 140px;
    transform: translateY(-50%);
}
#info-login-time {
    margin: 0 auto;
    height: fit-content;
    width: fit-content;
    margin-top: 10%;
    left: 50%;
    right: 50%;
    transform: translate(12%, 0);
}
#in-info-login-time-pic {
    float: left;
}
#in-info-login-time-word {
    text-align: left;
    margin-left: 25px;
    float: right;
}
#info-login-time-name {
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
}
#info-login-time-time-tile {
    font-size: 12px;
    line-height: 0px;
}
#info-login-time-time {
    font-size: 12px;
    line-height: 0px;
}
</style>
